class UGCSection extends HTMLElement {
  constructor() {
    super()

    this._doInit = this._doInit.bind(this)
  }

  connectedCallback() {
    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: 1.2,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerGroup: 1,
      a11y: {
        enabled: false,
      },
      navigation: {
        nextEl: '.ugc-carousel--icon-next',
        prevEl: '.ugc-carousel--icon-previous',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 4.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
        1200: {
          slidesPerView: 5.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: 6.5,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
          spaceBetween: 20,
        },
      }
    }

    this.$swiper = new Swiper('.js-ugc-section-swiper', option)
    this.$swiper.on('init', this._doInit)
    this.$swiper.on('resize', (swiper) => {
      this._doInit()
    })
    this.$swiper.init()
  }

  _doInit() {
    const imgWrapper = this.$swiper.el.querySelector(
      '.ugc-section--card_image',
    )
    if (imgWrapper) {
      const h = imgWrapper.getBoundingClientRect().height
      this.style.setProperty('--block-height', `${h}px`)
    }
  }
}

customElements.define('ugc-section', UGCSection)
